import React from 'react';
import clsx from 'clsx';

import CtaButton from '../../../Atoms/Cta/CtaButton';
import { GtmEvent } from 'lib/utils/gtm-utils';
import { BaseActionButtonProps } from '../BaseActionButtonProps';

import commonStyles from '../ActionButtonCommon.module.scss';
import { smoothScrollToElement } from 'lib/hooks/useScrollElementIntoView';

interface JumpToRecipeButtonProps extends BaseActionButtonProps {
  isSubAction?: boolean;
}

export function JumpToRecipeButton({
  label,
  variant,
  isSubAction = false,
  toolbarIdentifier,
  eventPositionSuffix,
}: JumpToRecipeButtonProps): JSX.Element {
  const handleClick = () => {
    let targetElement = document.getElementById('gmi-recipe-header');

    // Fallback target: recipe instructions & ingredients section
    if (!targetElement) {
      targetElement = document.getElementById('gmi-recipe-ingredients-instructions-section');
    }

    // If target found, smooth scroll to it
    if (targetElement) {
      smoothScrollToElement(targetElement);

      targetElement.focus();
    }
  };

  // Get position attribute for GTM tracking
  const getGtmPosition = (): string => {
    return [toolbarIdentifier, eventPositionSuffix].filter(Boolean).join('.') || '';
  };

  const gtmEvent: GtmEvent = {
    event: 'jump_to',
    position: getGtmPosition(),
  };

  const buttonClassName = clsx(
    commonStyles.actionButtonBase,
    commonStyles[`actionButton--${variant}`]
  );

  return (
    <div
      className={clsx({
        [commonStyles['actionButtonWrapper--horizontal']]: variant === 'horizontal',
      })}
    >
      <CtaButton
        ctaStyle={variant === 'horizontal' && !isSubAction ? 'link-invert-underline' : 'none'}
        ctaVariant="brand"
        type="button"
        onClick={handleClick}
        className={clsx(buttonClassName, isSubAction && commonStyles['actionButtonSubAction'])}
        gtmEvent={gtmEvent}
        ctaIconBefore="jump-to"
        ctaIconSize="sm"
        ctaIconNoSpacer={variant === 'vertical'}
        ctaIconClassName={commonStyles.icon}
        text={label}
      />
    </div>
  );
}
